// Back link for signup subflows; /signup/student & /signup/agency share sticky bar chrome (bg, pad, border).
// Mistake: only string `to` — wizard back needs Link state so /signup/student skips incomplete-login redirect.
// Mistake: sr-only back label was Korean-only; use common.login.btnBackAria for screen readers in every locale.
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { getLanguageValue } from "locales/i18n";
import { PAGE_TYPE } from "enums";

const SHELL_PAD = "px-4 sm:px-6 lg:px-8";

const Header = (props: any) => {
    const { backUrl, hideBackButton, titleText, onTitleClick } = props;
    const location = useLocation();
    const useStickySubflowChrome =
        location.pathname === "/signup/student" ||
        location.pathname.startsWith("/signup/student/register") ||
        location.pathname === "/signup/agency";

    const headerClass = useStickySubflowChrome
        ? ["w-full z-50 py-2", SHELL_PAD, "sticky top-0 border-b border-gray-100 bg-gray-50"].join(" ")
        : ["mb-4 w-full z-50"].join(" ");

    const innerClass = useStickySubflowChrome ? "mx-auto w-full max-w-4xl" : "container mx-auto";

    const backTo = backUrl != null && backUrl !== "" ? backUrl : "/";

    return (
        <header className={headerClass}>
            <div className={innerClass}>
                {/* grid: center column gets minmax(0,1fr) so title/button keeps a real hit area (flex justify-between squeezed middle) */}
                <div className="grid grid-cols-[2.5rem_minmax(0,1fr)_2.5rem] items-center gap-1 min-h-[44px] w-full">
                    <div className="flex justify-start min-w-0">
                        {!hideBackButton ? (
                            <Link to={backTo} className="inline-flex items-center justify-center p-2 rounded-full hover:bg-gray-100 shrink-0">
                                <span className="sr-only">{getLanguageValue(PAGE_TYPE.COMMON, "login.btnBackAria")}</span>
                                <svg className="w-8 h-8 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                </svg>
                            </Link>
                        ) : (
                            <span className="w-10 inline-block" aria-hidden />
                        )}
                    </div>
                    <div className="min-w-0 flex justify-center items-center px-1">
                        {titleText ? (
                            onTitleClick ? (
                                <button
                                    type="button"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        onTitleClick(e);
                                    }}
                                    className="max-w-full min-h-[40px] px-2 py-1 text-sm font-semibold text-gray-900 text-center line-clamp-2 sm:truncate sm:max-w-[min(100%,320px)] cursor-pointer hover:text-[#CF3688] hover:underline decoration-dotted underline-offset-2"
                                >
                                    {titleText}
                                </button>
                            ) : (
                                <p className="text-sm font-semibold text-gray-900 text-center line-clamp-2">{titleText}</p>
                            )
                        ) : (
                            <span />
                        )}
                    </div>
                    <span className="w-10 shrink-0" aria-hidden />
                </div>
            </div>
        </header>
    );
};

export default Header;
